import React from 'react';
import Espot from '../../ESpot/ESpot';

export default function CustomerCareEspot() {
  return (
    <Espot espotId="cust-helpalert" />
  );
}
